<template>
  <div class="mb-1">
    <div class="image-wrapper">
      <flicking
        ref="flick"
        :options="{ align: 'prev', circular: false,bound:true,autoResize:true }"
      >
        <div
          v-for="(image, index) in images"
          :key="index"
          class="flicking-panel image-container"
        >
          <feather-icon
            v-if="!$attrs.disabled"
            class="x-icon"
            icon="XCircleIcon"
            size="23"
            @click="removeImage(index, image.id)"
          />
          <b-img
            :src="blobs[index]"
            class="ml-1 pointer"
            rounded
            width="250em"
            height="250em"
            @click="showImagesPreview(index)"
          />
        </div>
      </flicking>

      <template v-if="images.length">
        <span
          class="buttons prev cursor-pointer"
          @click="$refs.flick.prev(500)"
        >
          <feather-icon
            icon="ArrowLeftIcon"
            size="22"
          />
        </span>
        <span
          class="buttons next cursor-pointer"
          @click="$refs.flick.next(500)"
        >
          <feather-icon
            icon="ArrowRightIcon"
            size="22"
          />
        </span>
      </template>
    </div>

    <vue-easy-lightbox
      move-disabled
      :visible="visible"
      :imgs="blobs"
      :index="imageIndex"
      @hide="handleHide"
    />
  </div>
</template>
<script>
import { Flicking } from '@egjs/vue-flicking'
import VueEasyLightbox from 'vue-easy-lightbox'
import handleAlerts from '@/compositions/common/handleAlerts'
import createBlobs from '@/compositions/common/createBlobs'
import Files from '@/compositions/Files/FilesAPI'

export default {
  name: 'ImagesPreview',
  components: {
    Flicking,
    VueEasyLightbox,
  },
  props: {
    images: { type: Array, default: () => [] },
  },
  data() {
    return {
      visible: false,
      imageIndex: 0,
    }
  },
  watch: {
    images(images) {
      this.convertFilesToBlob(images)
    },
  },
  setup() {
    const { blobs, convertFilesToBlob, clearBlobs } = createBlobs()
    const { confirmOperation } = handleAlerts()
    const { deleteFileRequest } = Files()
    return {
      blobs,
      convertFilesToBlob,
      clearBlobs,
      confirmOperation,
      deleteFileRequest,
    }
  },
  mounted() {
    this.convertFilesToBlob(this.images)
  },
  destroyed() {
    this.clearBlobs()
  },
  methods: {
    showImagesPreview(index) {
      this.imageIndex = index
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    removeImage(index, id) {
      this.confirmOperation().then(() => {
        this.deleteFileRequest(id).then(() => {
          this.$delete(this.images, index)
        })
      })
    },
  },
}
</script>
<style lang="scss">
</style>
<style lang="scss">
@import "~@egjs/vue-flicking/dist/flicking.css";

.image-container {
  position: relative;
}

.x-icon {
  position: absolute;
  top: 5px;
  right: 4px;
  color: rgb(235, 235, 235);
  background-color: rgba(105, 105, 105, 0.604);
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
}

.uploaded-image {
  height: 15em;
  width: 100%;
  border: 1px solid rgba(150, 150, 150, 0.303);
  padding: 0.7em;
}
.pointer {
  cursor: pointer;
}

.image-wrapper {
  position: relative;
  .buttons {
    width: 2em;
    text-align: center;
    font-weight: bolder;
    line-height: 2em;
    background: #666666c4;
    color: #fff;
  }
  .prev {
    position: absolute;
    top: 40%;
    left: 5%;
    z-index: 9;
  }
  .next {
    position: absolute;
    top: 40%;
    left: 92%;
    z-index: 9;
  }
}
</style>
